module.exports = __webpack_public_path__ + "img/2022_10_dandelion_monseki_fin_web.5cc311fe.jpg";